import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class AgentGpsPermissionsDisplayListComponent implements IController {
  gpsPermissions: string[];
  isRow: boolean;
  onChange: Function;

  constructor() {
  }

  $onInit() {
  }

  onRemove(gpsPermission: string) {
    this.onChange({gpsPermissions: _.filter(this.gpsPermissions, (gp: string) => {return gp !== gpsPermission})});
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentGpsPermissionsDisplayList', {
    bindings: {
      gpsPermissions: '<',
      isRow: '<?',
      onChange: '&'
    },
    template: require('./agent-gps-permissions-display-list.html').default,
    controller: AgentGpsPermissionsDisplayListComponent
  });
